// Implementation copied from this [comment](https://github.com/nuxt/nuxt/discussions/25973#discussioncomment-12203169).

export default defineNuxtPlugin(() => {
  if (import.meta.env.DEV) {
    const originalInfo = console.info;
    console.info = (...args: unknown[]) => {
      if (
        typeof args[0] === 'string' &&
        args[0].includes('<Suspense> is an experimental feature')
      ) {
        return; // terminate msg
      }
      originalInfo(...args);
    };
  }
});
